import React, { useEffect, useState } from "react";
import "../../CSS/ItemMaster.css";
import axios from "axios";
import LoadingScreen from "../LoadingScreen";
import "jspdf-autotable";
import { FaArrowLeft } from "react-icons/fa";
import { useSelector } from "react-redux";
import Select from "react-select";
import AllPagesNavbar from "../../Components/MasterNavbar/AllPagesMasterNavbar";

const ReturnActionsMaster = () => {
  const BASEURL_GLOBAL = process.env.REACT_APP_BASEURL_GLOBAL;
  const BASEURL = process.env.REACT_APP_BASEURL;
  const authToken = window.sessionStorage.getItem("auth-token");
  const sessionToken = window.sessionStorage.getItem("session-token");
  const [isloading, setisloading] = useState(true);
  const [search, setSearch] = useState("");
  const state = useSelector((state) => state.changeTheState.user);
  const user = state.emailId?.split("@")[0]?.toUpperCase();
  const [locationId, setLocationId] = useState("");
  const [locationName, setLocationName] = useState("");
  const [data, setData] = useState([]);

  const filteredData = data.filter((item) => {
    const searchData = search.toLowerCase().split(" ").filter(Boolean);

    if (searchData.length === 0) {
      return true;
    }

    const textMatch = searchData.every((term) => {
      return ["OM_ACTION_DESCRIPTION", "OM_ACTION_ID"].some((key) => {
        const columnValue = String(item[key]).toLowerCase();
        return columnValue.includes(term);
      });
    });

    return textMatch;
  });

  useEffect(() => {
    initialData();
  }, []);

  const initialData = () => {
    axios
      .get(`${BASEURL_GLOBAL}/globalViewHandler?viewname=1328`, {
        headers: {
          "auth-token": authToken,
          "session-token": sessionToken,
        },
      })
      .then((response) => {
        setLocationId(response?.data[0]?.NEWREASONID);
      })
      .catch((error) => {
        setisloading(false);
        console.error("Error fetching New Wb No :", error);
      });

    axios
      .get(`${BASEURL_GLOBAL}/globalViewHandler?viewname=1327`, {
        headers: {
          "auth-token": authToken,
          "session-token": sessionToken,
        },
      })
      .then((response) => {
        setData(response?.data);
        setisloading(false);
      })
      .catch((error) => {
        setisloading(false);
        console.error("Error fetching WeighBridge details:", error);
      });
  };

  // Saving
  async function SaveGateIn() {
    setisloading(true);
    try {
      const response = await axios.post(
        `${BASEURL_GLOBAL}/globalSpHandler?spname=1329`,
        {
          OM_ACTION_ID: Number(locationId),
          OM_ACTION_DESCRIPTION: locationName,
          OM_ACTION_CREATED_BY: user,
          SUCCESS_STATUS: "",
          ERROR_STATUS:"",
        },
        {
          headers: {
            "auth-token": authToken,
            "session-token": sessionToken,
          },
        }
      );

      if (response.status === 201) {
        setisloading(false);
        alert(`Return Action Master Saved successfully`);
        console.log(`Return Action Master Saved successfully`);
      } else {
        setisloading(false);
        console.error(`Error while saving Return Action Master`);
      }
    } catch (error) {
      setisloading(false);
      console.error(`Error while saving Return Action Master`, error);
    }
  }

  const handleRowClick = (value, index) => {
    setLocationId(value.OM_ACTION_ID);
    setLocationName(value.OM_ACTION_DESCRIPTION);
  };

  if (isloading) {
    return <LoadingScreen />;
  }

  return (
    <div className="min-h-screen">
      <AllPagesNavbar />
      <div className="flex justify-between">
        <h1 className="lg:text-3xl font-extrabold underline text-blue-600">
          Return Actions Master
        </h1>
      </div>

      <div className="flex justify-center mt-6">
        <div className="bg-white border border-gray-300 shadow-md rounded-lg p-6 w-[95%] lg:w-[1150px]">
          {/* Save Button */}
          <div className="flex justify-end gap-3 mb-4">
            <button
              className="flex items-center justify-center bg-[#002d62] hover:bg-[#004080] text-white font-semibold rounded-md px-4 py-2 transition-all duration-200 border border-black"
              onClick={() => {
                window.location.reload();
              }}
            >
              New
            </button>

            <button
              className="flex items-center justify-center bg-[#002d62] hover:bg-[#004080] text-white font-semibold rounded-md px-4 py-2 transition-all duration-200 border border-black"
              onClick={async () => {
                if (!locationName) {
                  alert("Kindly Supply Return Action Name");
                  return;
                } else {
                  await SaveGateIn();
                  window.location.reload();
                }
              }}
            >
              Save
            </button>
          </div>

          <div className="flex flex-col lg:flex-row gap-4">
            <div className="flex flex-col lg:flex-row gap-2 w-full lg:w-auto">
              <label className="text-red-600 font-medium min-w-max mt-0">
                 Return Action Id :
              </label>
              <input
                className="w-full lg:w-20 h-8 lg:ml-2 border border-gray-400 rounded-md px-3 focus:outline-none focus:border-blue-500 text-right"
                type="text"
                value={locationId}
                readOnly
              />
            </div>

            <div className="flex flex-col lg:flex-row gap-2 w-full lg:w-auto">
              <label className="text-red-600 font-medium min-w-max mt-0 lg:ml-12">
                 Return Action Name:
              </label>
              <input
                className="w-full lg:w-64 h-8 lg:ml-2 border border-gray-400 rounded-md px-3 focus:outline-none focus:border-blue-500"
                type="text"
                value={locationName}
                onChange={(e) => setLocationName(e.target.value)}
              />
            </div>
          </div>
        </div>
      </div>

      <div className="select_product_type" style={{ marginTop: "5px" }}>
        <div>
          <p>Search</p>
        </div>
        <div>
          <input
            type="text"
            className="w-64 h-8 border border-black rounded-md"
            value={search}
            onChange={(e) => {
              setSearch(e.target.value);
            }}
          ></input>
        </div>
      </div>

      <div className="visible lg:h-[500px] p-1 z-0 lg:overflow-auto mt-2">
        <table className="w-full border border-gray-300 text-sm">
          <thead className="sticky top-0">
            <tr className="bg-[#2b3f5c] text-white text-[12px]">
              <td className="py-2 px-4 text-left border border-gray-300">
                SNO
              </td>
              <td className="py-2 px-4 text-left border border-gray-300">
                RETURN ACTION ID
              </td>
              <td className="py-2 px-4 text-left border border-gray-300">
                RETURN ACTION NAME
              </td>
            </tr>
          </thead>
          <tbody>
            {filteredData.map((value, index) => (
              <tr
                key={index}
                className="hover:bg-gray-100 cursor-pointer text-[13px]"
                onClick={() => handleRowClick(value, index)}
              >
                <td className="py-2 px-4 text-right border border-gray-300">
                  {index + 1}
                </td>
                <td className="py-2 px-4 text-left border border-gray-300">
                  {value.OM_ACTION_ID || "N/A"}
                </td>
                <td className="py-2 px-4 text-left border border-gray-300">
                  {value.OM_ACTION_DESCRIPTION || "N/A"}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default ReturnActionsMaster;
